export type AssetType = 'image' | 'pdf' | 'doc' | 'unknown';

function extensionAssetType(fileName: string): AssetType | null {
  const ext = fileName.split('.').pop()?.toLowerCase();
  if (!ext) return null;
  if (['jpg', 'jpeg', 'png'].includes(ext)) return 'image';
  if (ext === 'pdf') return 'pdf';
  if (['doc', 'docx'].includes(ext)) return 'doc';
  return null;
}

export function getAssetType(mimeType: string, fileName?: string): AssetType {
  if (['image/jpeg', 'image/jpg', 'image/png'].includes(mimeType)) return 'image';
  if (mimeType === 'application/pdf') return 'pdf';
  if (
    mimeType === 'application/msword' ||
    mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ) {
    return 'doc';
  }
  if (fileName) {
    const fromExt = extensionAssetType(fileName);
    if (fromExt) return fromExt;
  }
  return 'unknown';
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const ATTACHMENT_ACCEPT = '.jpg,.jpeg,.png,.pdf,.doc,.docx';

export const MAX_ATTACHMENT_FILE_BYTES = 10 * 1024 * 1024;

/** Placeholder body when sending attachments without text (API requires non-empty content). */
export const ATTACHMENT_ONLY_COMMENT = '📎';
